const style = (theme) => {
  const output = {
    root: {
      overflow: 'hidden',
    },
    container: {
      extend: theme.wrapper,
      margin: '0 auto',
    },
    containerTop: {
      overflowX: 'hidden',
      paddingTop: 100,
    },
    containerBottom: {
      background: theme.colors[3],
      position: 'relative',
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: 20,
        zIndex: 0,
        top: -10,
        left: 0,
        background: theme.colors[3],
      },
    },
    containerLight: {
      background: theme.colors[1],
    },
    wrapper: {},
    wrapperBottom: {
      padding: '50px 0',
      display: 'flex',
      justifyContent: 'space-between',
    },
    wrapperTop: {
      position: 'relative',
      '&::before': {
        content: '""',
        display: 'block',
        width: '150vw',
        height: '70%',
        position: 'absolute',
        zIndex: 0,
        bottom: 0,
        left: '-50vw',
        background: theme.colors[3],
      },
    },
    logo: {
      width: 73,
      height: 16,
      '& svg': {
        width: '100%',
        height: '100%',
        fill: theme.colors[1],
      },
    },
    footerCopy: {
      display: 'flex',
      color: theme.colors[1],
      '& > *': {
        marginBottom: 0,
        fontSize: 13,
        '&:not(:last-child)': {
          marginRight: 40,
        },
      },
      '& p': {
        marginBottom: 0,
      },
    },
    footerBox: {
      position: 'relative',
      zIndex: 1,
      background: theme.colors[4],
      borderRadius: 20,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      padding: '80px 8.3vw',
      display: 'flex',
      justifyContent: 'space-between',
      '& h2': {
        fontSize: 43,
        marginBottom: 30,
        color: theme.colors[1],
      },
    },
    footerMenu: {
      display: 'flex',
      flexDirection: 'column',
      '& li:not(:last-child)': {
        marginBottom: 10,
      },
      '& a': {
        color: theme.colors[1],
        fontSize: 20,
        position: 'relative',
        '&:after': {
          content: '""',
          bottom: '-1px',
          display: 'block',
          height: 2,
          left: 0,
          position: 'absolute',
          background: 'currentColor',
          transition: 'width 0.4s ease 0s',
          width: 0,
        },
        '&:hover': {
          '&:after': {
            width: '100%',
          },
        },
      },
      '& .secondary': {
        '&:not(:last-child)': {
          marginBottom: 5,
        },
        '& a': {
          color: theme.getRgba(theme.colors[1], 0.3),
          fontSize: 18,
        },
      },
    },
    iconsList: {
      '& > *:not(:last-child)': {
        marginBottom: 40,
      },
    },
    itemList: {
      display: 'flex',
      '& svg': {
        width: 15,
        height: 15,
        fill: theme.colors[1],
        marginTop: 5,
        marginRight: 15,
      },
      '& p': {
        fontSize: 16,
        color: theme.getRgba(theme.colors[1], 0.4),
        marginBottom: 0,
      },
    },
    btn: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.colors[1],
      color: theme.colors[3],
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius: 6,
      fontSize: 10,
      textTransform: 'uppercase',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '&:hover': {
        backgroundColor: theme.colors[0],
        color: theme.colors[1],
      },
    },
    locator: {
      padding: '140px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      lineHeight: 1,
      '& h2': {
        color: theme.colors[3],
        fontSize: 95,
        marginBottom: 40,
        '& p': {
          margin: 0,
        },
      },
    },
    locatorText: {
      color: theme.colors[5],
      fontSize: 16,
      marginBottom: 60,
    },
    locatorBtns: {
      display: 'flex',
      '& > *:not(:last-child)': {
        marginRight: 20,
      },
    },
    rootLight: {
      background: theme.colors[1],
    },
    footer__social: {
      marginBottom: 40,
      '& a svg': {
        fill: theme.colors[1],
        height: 15,
        width: 15,
        verticalAlign: 'middle',
        marginRight: 17,
      },
    },
  }

  output[theme.mediaInverse.md] = {
    wrapperBottom: {
      flexDirection: 'column',
    },
    footerCopy: {
      marginTop: 20,
      flexDirection: 'column',
    },
    footerBox: {
      padding: '40px 5vw',
      '& h2': {
        fontSize: 30,
      },
    },
    footerMenu: {
      '& a': {
        fontSize: 16,
      },
      '& .secondary': {
        '& a': {
          fontSize: 14,
        },
      },
    },
    locator: {
      '& h2': {
        fontSize: 80,
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    footerBox: {
      padding: 40,
      flexDirection: 'column',
      '& h2': {
        marginBottom: 30,
      },
    },
    footerMenu: {
      marginTop: 40,
    },
    locator: {
      padding: '80px 20px',
      '& h2': {
        fontSize: 60,
      },
    },
    locatorBtns: {
      flexDirection: 'column',
      justifyContent: 'center',
      '& > *:not(:last-child)': {
        marginRight: 0,
        marginBottom: 20,
      },
    },
  }

  return output
}

export default style
